var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 5.001a1.25 1.25 0 011.117-.692h2.5a1.25 1.25 0 011.116.692L33.2 8.334a1.25 1.25 0 01-.032 1.179l-1.501 2.63v8.833h2.083a1.25 1.25 0 011.25 1.25v2.917H23.334v-2.917a1.25 1.25 0 011.25-1.25h2.083v-8.833l-1.502-2.63a1.25 1.25 0 01-.033-1.179L26.8 5.001zm-3.466 22.642v4.166a5.833 5.833 0 0011.666 0v-4.166H23.334zm-8.62-22.98a1.25 1.25 0 011.163-.127 9.17 9.17 0 01.85 16.66v12.22a4.227 4.227 0 01-8.453 0v-12.22a9.17 9.17 0 01.85-16.66 1.25 1.25 0 011.71 1.162v6.111a1.666 1.666 0 103.333 0V5.698a1.25 1.25 0 01.546-1.034",
    fill: "#DFE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.ad8f5a04c9cbca187524598a59a9912f.svg";
export { ForwardRef as ReactComponent };